import React, { useState } from 'react';
import { Send, Phone, Mail, MapPin } from 'lucide-react';
import { contactFormSubmit } from '../mock';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    investmentInterest: '',
    investmentAmount: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const result = await contactFormSubmit(formData);
      if (result.success) {
        setSubmitMessage(result.message);
        setFormData({
          name: '',
          email: '',
          phone: '',
          investmentInterest: '',
          investmentAmount: '',
          message: ''
        });
      }
    } catch (error) {
      setSubmitMessage('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section-dark">
      <div className="container-standard">
        <div className="section-header">
          <h2 className="section-title">Get Started Today</h2>
          <p className="section-subtitle">
            Schedule a consultation with our investment advisors to discuss your financial goals
          </p>
        </div>

        <div className="contact-wrapper">
          <div className="contact-form-section">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="form-label">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="form-input"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone" className="form-label">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="form-input"
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="investmentInterest" className="form-label">Investment Interest *</label>
                  <select
                    id="investmentInterest"
                    name="investmentInterest"
                    value={formData.investmentInterest}
                    onChange={handleChange}
                    className="form-input"
                    required
                  >
                    <option value="">Select an option</option>
                    <option value="stock-market">Stock Market Investment</option>
                    <option value="real-estate">Real Estate Investment</option>
                    <option value="tech-startups">Technology Startups</option>
                    <option value="tax-strategy">Tax Strategy Planning</option>
                    <option value="equipment-lease">Heavy Equipment Lease</option>
                    <option value="oil-gas">Oil & Gas Exploration</option>
                    <option value="diversified">Diversified Portfolio</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="investmentAmount" className="form-label">Investment Range *</label>
                  <select
                    id="investmentAmount"
                    name="investmentAmount"
                    value={formData.investmentAmount}
                    onChange={handleChange}
                    className="form-input"
                    required
                  >
                    <option value="">Select a range</option>
                    <option value="50k-100k">$50,000 - $100,000</option>
                    <option value="100k-250k">$100,000 - $250,000</option>
                    <option value="250k-500k">$250,000 - $500,000</option>
                    <option value="500k-1m">$500,000 - $1,000,000</option>
                    <option value="1m-plus">$1,000,000+</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-input form-textarea"
                  rows="4"
                  placeholder="Tell us more about your investment goals..."
                />
              </div>

              <button type="submit" className="btn-primary btn-full" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Schedule Consultation'}
                <Send size={20} />
              </button>

              {submitMessage && (
                <div className="submit-message">{submitMessage}</div>
              )}
            </form>
          </div>

          <div className="contact-info-section">
            <div className="contact-info-card">
              <h3 className="contact-info-title">Contact Information</h3>
              <div className="contact-info-items">
                <div className="contact-info-item">
                  <Phone size={20} />
                  <div>
                    <div className="contact-info-label">Phone</div>
                    <div className="contact-info-value">+1 (949) 694-1009</div>
                  </div>
                </div>
                <div className="contact-info-item">
                  <Mail size={20} />
                  <div>
                    <div className="contact-info-label">Email</div>
                    <div className="contact-info-value">invest@infinitycapitalinc.com</div>
                  </div>
                </div>
                <div className="contact-info-item">
                  <MapPin size={20} />
                  <div>
                    <div className="contact-info-label">Headquarters</div>
                    <div className="contact-info-value">650 Newport Center Drive, Suite 2020<br />Newport Beach, CA 92660</div>
                  </div>
                </div>
              </div>

              <div className="contact-hours">
                <h4 className="contact-hours-title">Business Hours</h4>
                <p className="contact-hours-text">Monday - Friday: 8:00 AM - 6:00 PM EST</p>
                <p className="contact-hours-text">Saturday: 9:00 AM - 2:00 PM EST</p>
                <p className="contact-hours-text">Sunday: Closed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
